/**
 * TxtReport Form - Manejo del formulario de generación de reporte TXT
 */
export class TxtReportForm {
    constructor() {
        this.form = document.getElementById('txtReportForm');
        this.dateFromInput = document.getElementById('date_from');
        this.dateToInput = document.getElementById('date_to');
        this.yesterdayBtn = document.querySelector('[data-action="set-yesterday"]');
        this.todayBtn = document.querySelector('[data-action="set-today"]');
        this.init();
    }
    init() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                this.initializeForm();
            });
        }
        else {
            this.initializeForm();
        }
    }
    initializeForm() {
        if (!this.form) {
            return;
        }
        // Set default dates to yesterday
        this.setYesterday();
        // Setup event listeners
        this.setupEventListeners();
    }
    setupEventListeners() {
        // Yesterday button
        if (this.yesterdayBtn) {
            this.yesterdayBtn.addEventListener('click', () => this.setYesterday());
        }
        // Today button
        if (this.todayBtn) {
            this.todayBtn.addEventListener('click', () => this.setToday());
        }
        // Form validation
        if (this.form) {
            this.form.addEventListener('submit', (e) => this.handleFormSubmit(e));
        }
    }
    setYesterday() {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        const dateStr = this.formatDate(yesterday);
        if (this.dateFromInput) {
            this.dateFromInput.value = dateStr;
        }
        if (this.dateToInput) {
            this.dateToInput.value = dateStr;
        }
    }
    setToday() {
        const today = new Date();
        const dateStr = this.formatDate(today);
        if (this.dateFromInput) {
            this.dateFromInput.value = dateStr;
        }
        if (this.dateToInput) {
            this.dateToInput.value = dateStr;
        }
    }
    formatDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    handleFormSubmit(e) {
        if (!this.dateFromInput || !this.dateToInput) {
            return;
        }
        const dateFrom = this.dateFromInput.value.trim();
        const dateTo = this.dateToInput.value.trim();
        // Validate dates are not empty
        if (!dateFrom || !dateTo) {
            e.preventDefault();
            this.showAlert('Por favor selecciona ambas fechas.', 'danger');
            return;
        }
        // Validate date range
        const fromDateObj = new Date(dateFrom);
        const toDateObj = new Date(dateTo);
        if (fromDateObj > toDateObj) {
            e.preventDefault();
            this.showAlert('La fecha inicial no puede ser mayor a la fecha final.', 'danger');
            this.dateFromInput.focus();
            return;
        }
        // Check if date range is too large (optional: max 31 days)
        const daysDiff = Math.floor((toDateObj.getTime() - fromDateObj.getTime()) / (1000 * 60 * 60 * 24));
        if (daysDiff > 31) {
            e.preventDefault();
            this.showAlert('El rango de fechas no puede ser mayor a 31 días.', 'warning');
            return;
        }
    }
    showAlert(message, type) {
        const alertDiv = document.createElement('div');
        alertDiv.className = `alert alert-${type} alert-dismissible fade show`;
        alertDiv.setAttribute('role', 'alert');
        alertDiv.innerHTML = `
            <i class="bi bi-${this.getAlertIcon(type)} me-2"></i>${message}
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        `;
        // Insert at the beginning of the card body
        const cardBody = this.form?.closest('.card-body');
        if (cardBody) {
            cardBody.insertBefore(alertDiv, cardBody.firstChild);
            // Auto-close after 5 seconds
            setTimeout(() => {
                alertDiv.remove();
            }, 5000);
        }
    }
    getAlertIcon(type) {
        switch (type) {
            case 'success':
                return 'check-circle';
            case 'danger':
                return 'exclamation-triangle';
            case 'warning':
                return 'exclamation-circle';
            case 'info':
                return 'info-circle';
            default:
                return 'info-circle';
        }
    }
}
export default TxtReportForm;
